import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXConfirmModal from "../../../../Components/Modals/BMXConfirmModal/BMXConfirmModal";
import ConfirmWarningModal from "../../ConfirmModalsForms/ConfirmWarningModal/ConfirmWarningModal";
import { useState } from "react";

const ConfirmModal = (props) => {
  const { handleHide, show, confirmButtonName } = props;

  const formName = "ConfirmForm";
  const { t } = useTranslation();
  const [pending, setPending] = useState(false);

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="submit"
          type="subbmit"
          buttontype={"Button"}
          bmxclass={`${pending ? "grey" : "secondary "} background`}
          form={formName}
          disabled={pending}
        >
          {confirmButtonName ? t(`${confirmButtonName}`) : t("global:delete")}
        </BMXButton>
      </>
    );
  };

  return (
    <BMXConfirmModal
      {...props}
      open={show}
      width={"500px"}
      height={"250px"}
      onClose={handleHide}
      buttons={buttons()}
    >
      <ConfirmWarningModal
        {...props}
        setPending={setPending}
        formName={formName}
        handleHide={handleHide}
      />
    </BMXConfirmModal>
  );
};

export default connectModal({ name: "ConfirmModal" })(ConfirmModal);
